export default {"src":"/_next/static/media/thumb_img1.e815d4e9.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};